import * as React from "react";
import { IPERCArea } from "../../../../Interfaces/IIPERC";
import { useState, useEffect } from "react";
import IPERCService from "../../../../services/IPERCService";
import {
  ICommandBarItemProps,
  Icon,
  TooltipHost,
  Link,
  Stack,
} from "@fluentui/react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useBoolean } from "@fluentui/react-hooks";
import {
  DetailsListLayoutMode,
  IColumn,
} from "@fluentui/react/lib/DetailsList";
import HeaderTable from "../../../../components/generic/HeaderTable";
import { TableBase } from "../../../../components/Table/TableBase";
import IconHelper from "../../../../utils/helpers/iconHelper";
import DialogDeleteBase from "../../../../components/generic/DialogDeleteBase";
import { PanelEditarArea } from "./PanelEditarArea";
import {
  IEditarArea,
  InitialEditarArear,
} from "../../../../Interfaces/IPERC/IArea";
import { PanelCrearArea } from "./PanelCrearArea";
import { Navigate, useNavigate } from "react-router-dom";
import { ConfigHelper } from "../../../../utils/helpers/configHelper";

const classNames = mergeStyleSets({
  fileIconHeaderIcon: {
    padding: 0,
    fontSize: "16px",
  },
  iconFont: {
    padding: 0,
    fontSize: "16px",
    marginRight: 5,
  },
  iconFontGreen: {
    padding: 0,
    fontSize: "16px",
    marginRight: 5,
    color: "#004b1c",
    fontWeight: "bold",
  },
  fileIconCell: {
    textAlign: "center",
    selectors: {
      "&:before": {
        content: ".",
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0px",
        visibility: "hidden",
      },
    },
  },
  fileIconImg: {
    verticalAlign: "middle",
    maxHeight: "16px",
    maxWidth: "16px",
  },
  controlWrapper: {
    display: "flex",
    flexWrap: "wrap",
  },
  exampleToggle: {
    display: "inline-block",
    marginBottom: "10px",
    marginRight: "30px",
  },
  selectionDetails: {
    marginBottom: "20px",
  },
});

function ConfiguracionAreasIperc() {
  const navigate = useNavigate();
  const [items, setItems] = useState<IPERCArea[]>([]);
  const [
    isOpenPanelEditar,
    { setTrue: openPanelEditar, setFalse: onDismissPanelEditar },
  ] = useBoolean(false);
  const [
    isOpenPanelCrear,
    { setTrue: openPanelCrear, setFalse: onDismissPanelCrear },
  ] = useBoolean(false);

  const [modelEditarArea, setModelEditarArea] =
    useState<IEditarArea>(InitialEditarArear);

  const [model, setmodel] = useState<IEditarArea>(InitialEditarArear);

  function LoadData() {
    IPERCService.listaAreas().then((x) => {
      setItems(x.data);
    });
  }
  const [hideDialogDelete, { toggle: toggleHideDialogDelete }] =
    useBoolean(true);

  useEffect(() => {
    LoadData();
  }, []);

  const _farItems: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_ADD,
      text: "Nuevo",
      onClick: () => {
        openPanelCrear();
      },
    },
  ];

  const _columns: IColumn[] = [
    {
      key: "nombre",
      name: "Nombre",
      fieldName: "nombre",
      minWidth: 400,
      maxWidth: 500,
      isResizable: true,
      isMultiline: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      fieldName: "opciones",
      minWidth: 70,
      maxWidth: 90,
      isResizable: true,
      isCollapsible: true,
      data: "number",
      onRender: (item: IPERCArea) => (
        <>
          <TooltipHost content={"Editar"}>
            <Icon
              iconName="edit"
              className={classNames.iconFont}
              style={{ cursor: "pointer", color: "black" }}
              onClick={() => {
                openPanelEditar();
                setModelEditarArea({
                  ...modelEditarArea,
                  areaId: item.areaId,
                  nombre: item.nombre,
                });
              }}
            />
          </TooltipHost>
          <TooltipHost content={"Ubicaciones"}>
            {/* <Link href={`ubicaciones/${item.areaId}`}>
              <Icon
                iconName="GroupedList"
                className={classNames.iconFont}
                style={{ cursor: "pointer", color: "black" }}
              />
            </Link> */}
            <Icon
              iconName="GroupedList"
              className={classNames.iconFont}
              style={{ cursor: "pointer", color: "black" }}
              onClick={() => {
                navigate(`${ConfigHelper.urlBase()}/iperc/Configuraciones/ubicaciones`, {
                  state: { areaId: `${item.areaId}` }
                });
              }}
            />
          </TooltipHost>
          <TooltipHost content={"Eliminar"}>
            <Icon
              iconName="Trash"
              className={classNames.iconFont}
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => {
                toggleHideDialogDelete();
                setmodel({ ...model, areaId: item.areaId });
              }}
            />
          </TooltipHost>
        </>
      ),
    },
  ];

  const _confirmDeleteDialog = () => {
    var body: any = {};
    body.id = model.areaId;
    IPERCService.eliminarArea(body).then((x) => {
      toggleHideDialogDelete();
      LoadData();
    });
  };

  return (
    <div
      className="ms-Grid-col ms-md12 ms-lg12"
      style={{ padding: "0.625rem" }}
    >
      <Stack styles={{ root: { height: "calc(100vh - 4.25rem)" } }}>
        <HeaderTable
          horizontalAlign="start"
          title="Áreas"
          subTitle="Gestión de Áreas"
          iconName="Org"
        />
        <br />
        <Stack>
          <TableBase
            leftBar={_farItems}
            data={items}
            column={_columns}
            isLoading={false}
            getPageSize={(arg) => { }}
            layout={DetailsListLayoutMode.justified}
          />
        </Stack>
      </Stack>

      <DialogDeleteBase
        hidden={hideDialogDelete}
        onDismiss={toggleHideDialogDelete}
        hidePropressDelete={false}
        cancelar={() => {
          toggleHideDialogDelete();
          LoadData();
        }}
        eliminar={_confirmDeleteDialog}
      />

      <PanelEditarArea
        isOpen={isOpenPanelEditar}
        onDismiss={onDismissPanelEditar}
        modelRequest={modelEditarArea}
        loadData={LoadData}
      />
      <PanelCrearArea
        isOpen={isOpenPanelCrear}
        onDismiss={onDismissPanelCrear}
        loadData={LoadData}
      />
    </div>
  );
}

export default ConfiguracionAreasIperc;
